export default __webpack_public_path__ + "static/media/level_star_02_inactive.4d28e6f1.svg";